// Lista dei contatti in Otello da mobile (docs/mobile-web/README.md,
// "Contatti"). Stessi dati e stesse chiamate della tabella desktop: qui solo
// i piccoli calcoli della lista a scorrimento continuo.

// Ordinamenti del mockup, nell'ordine in cui il pulsante li fa girare. Le
// chiavi sono quelle della tabella desktop (ContactsTable, sortConfig).
const MOBILE_CONTACT_SORTS = [
  { key: 'last_activity', config: { last_activity_at: 'desc' } },
  { key: 'name', config: { name: 'asc' } },
  { key: 'created_at', config: { created_at: 'desc' } },
];

const resolveMobileContactSort = (sortConfig = {}) => {
  const [field] =
    Object.entries(sortConfig || {}).find(([, order]) => Boolean(order)) || [];
  return (
    MOBILE_CONTACT_SORTS.find((sort) => field in sort.config) ||
    MOBILE_CONTACT_SORTS[0]
  );
};

const nextMobileContactSort = (sortConfig = {}) => {
  const current = resolveMobileContactSort(sortConfig);
  const index = MOBILE_CONTACT_SORTS.indexOf(current);
  return MOBILE_CONTACT_SORTS[(index + 1) % MOBILE_CONTACT_SORTS.length];
};

// Pagina successiva accodata: gli id gia' in lista (un contatto che si e'
// spostato tra una pagina e l'altra) non si ripetono.
const appendContactSortOrder = (sortOrder = [], ids = []) => {
  const safeOrder = Array.isArray(sortOrder) ? sortOrder : [];
  const seen = new Set(safeOrder);
  const appended = (Array.isArray(ids) ? ids : []).filter((id) => {
    if (seen.has(id)) return false;
    seen.add(id);
    return true;
  });
  return [...safeOrder, ...appended];
};

const hasMoreMobileContacts = ({ loaded = 0, total = 0 } = {}) =>
  Number(total) > Number(loaded);

// Sotto il nome: l'email, altrimenti il telefono.
const resolveMobileContactDetail = (contact = {}) =>
  contact?.email || contact?.phone_number || '';

// Sotto il nome nella scheda: citta' e paese.
const resolveMobileContactPlace = (contact = {}) => {
  const attributes = contact?.additional_attributes || {};
  return [attributes.city, attributes.country].filter(Boolean).join(', ');
};

// "Conversazione" nella scheda apre la piu' recente.
const resolveLatestContactConversationId = (conversations = []) => {
  const safe = Array.isArray(conversations) ? conversations : [];
  const latest = safe.reduce((best, conversation) => {
    if (!conversation?.id) return best;
    const time =
      Number(conversation.last_activity_at || conversation.timestamp) || 0;
    return !best || time > best.time ? { id: conversation.id, time } : best;
  }, null);
  return latest ? latest.id : null;
};

export {
  MOBILE_CONTACT_SORTS,
  appendContactSortOrder,
  hasMoreMobileContacts,
  nextMobileContactSort,
  resolveLatestContactConversationId,
  resolveMobileContactDetail,
  resolveMobileContactPlace,
  resolveMobileContactSort,
};
